import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import ProjectLeads from './leads';
import rootReducer from 'bundles/project/reducers';
import { applyMiddleware } from 'helpers/redux_dev_tools';
import LocalStoreFactory from 'helpers/redux/local_store_factory';

const LEADS_TAB_KEY = 'leadsTab';

export default function Leads(props) {
  const startingState = {
    availableDatabaseOptions: props.availableDatabaseOptions,
    currentUser: props.currentUser,
    features: {
      projectTasksActivities: false,
      clientReport: false,
    },
    leads: { fetching: true },
    leadsOptions: {
      selectOptions: {
        referralSources: props.leadReferralSources,
        statuses: props.leadStatuses
      }
    },
    project: props.project,
    session: {
      currentColumns: null,
      currentCompanyColumns: null,
      currentPersonColumns: null
    },
    tasks: { fetching: true },
    leadShow: {
      isCaUploading: false
    }
  };

  const storeFactory = new LocalStoreFactory(LEADS_TAB_KEY, { permit: ['session'] });
  const store = storeFactory.store(rootReducer, startingState, applyMiddleware(thunk));

  if (module.hot) {
    module.hot.accept('bundles/project/reducers/index', () => {
      store.replaceReducer(require('bundles/project/reducers/index'));
    });
  }

  return (
    <Provider store={store}>
      <ProjectLeads
        availableDatabaseOptions={props.availableDatabaseOptions}
        caDownloadPath={props.caDownloadPath}
        callLists={props.callLists}
        callListsEnabled={props.currentUser && props.currentUser.callListsEnabled}
        canDisplayEmailLink={props.canDisplayEmailLink}
        commercialEdgeLogoPath={props.commercialEdgeLogoPath}
        databaseMembers={[...props.project.collaborators, ...props.project.otherAuthorizedUsers]}
        defaultTaskAssignee={props.defaultTaskAssignee}
        leadReferralSources={props.leadReferralSourceFilterOptions}
        leadsPath={props.leadsPath}
        leadStatuses={props.leadStatuses}
        project={props.project}
      />
    </Provider>
  );
}

Leads.propTypes = {
  availableDatabaseOptions: PropTypes.array,
  caDownloadPath: PropTypes.string,
  callLists: PropTypes.array,
  canDisplayEmailLink: PropTypes.bool,
  commercialEdgeLogoPath: PropTypes.string,
  currentUser: PropTypes.object,
  defaultTaskAssignee: PropTypes.object,
  leadReferralSourceFilterOptions: PropTypes.array,
  leadReferralSources: PropTypes.array,
  leadsPath: PropTypes.string,
  leadStatuses: PropTypes.array,
  project: PropTypes.object,
};